export enum WorkshopTypes {
  CEMETERY = 'CEMETERY',
  WORKSHOP = 'WORKSHOP'
}
